const messages = {
  en: {
    // Disconnect
    disconnectTitle: "Disconnecting QuickBooks?",
    disconnectBody:
      "Disconnecting your QuickBooks bridge is disconnecting the data passage. If your status remains disconnected on your date of renewal your subscription is automatically cancelled.",
    disconnectConfirm: "Disconnect",
    // Cancel subscription
    cancelTitle: "Subscription cancellation",
    cancelConfirmMessage:
      "Your subscription will remain active until {date}. After that date, your QuickBooks integration will be disconnected.",
    cancelConfirmMessageNoDate:
      "Your subscription will be cancelled and your QuickBooks integration will be disconnected.",
    cancelConfirm: "Cancel subscription",
    // Reactivate
    reactivateTitle: "Reactivate Subscription",
    reactivateConfirmMessage:
      "Your pending cancellation will be reversed. Your {plan} subscription will continue as normal.",
    reactivateConfirm: "Reactivate",
    // Plan labels
    planMonthly: "Monthly",
    planYearly: "Yearly",
    // Errors
    errorTitle: "An error has occurred",
    errorBodyDisconnect:
      "There was an error while processing your disconnection.\nPlease try again.",
    errorBodyCancel:
      "There was an error while processing your cancellation.\nPlease try again.",
    errorBodyReactivate:
      "There was an error while processing your reactivation.\nPlease try again.",
    errorRetry: "Retry",
    errorNoSubscription: "No active subscription found.",
    errorGeneric: "Something went wrong. Please try again.",
  },
  fr: {
    // Disconnect
    disconnectTitle: "D\u00e9connecter QuickBooks?",
    disconnectBody:
      "D\u00e9connecter votre pont QuickBooks, c\u2019est d\u00e9connecter le passage des donn\u00e9es. Si votre statut reste d\u00e9connect\u00e9 \u00e0 la date de renouvellement, votre abonnement est automatiquement annul\u00e9.",
    disconnectConfirm: "D\u00e9connecter",
    // Cancel subscription
    cancelTitle: "Annulation de l\u2019abonnement",
    cancelConfirmMessage:
      "Votre abonnement restera actif jusqu\u2019au {date}. Apr\u00e8s cette date, votre int\u00e9gration QuickBooks sera d\u00e9connect\u00e9e.",
    cancelConfirmMessageNoDate:
      "Votre abonnement sera annul\u00e9 et votre int\u00e9gration QuickBooks sera d\u00e9connect\u00e9e.",
    cancelConfirm: "Annuler l\u2019abonnement",
    // Reactivate
    reactivateTitle: "R\u00e9activer l\u2019abonnement",
    reactivateConfirmMessage:
      "Votre annulation en attente sera annul\u00e9e. Votre abonnement {plan} continuera normalement.",
    reactivateConfirm: "R\u00e9activer",
    // Plan labels
    planMonthly: "Mensuel",
    planYearly: "Annuel",
    // Errors
    errorTitle: "Une erreur est survenue",
    errorBodyDisconnect:
      "Une erreur est survenue lors du traitement de votre d\u00e9connexion.\nVeuillez r\u00e9essayer.",
    errorBodyCancel:
      "Une erreur est survenue lors du traitement de votre annulation.\nVeuillez r\u00e9essayer.",
    errorBodyReactivate:
      "Une erreur est survenue lors du traitement de votre r\u00e9activation.\nVeuillez r\u00e9essayer.",
    errorRetry: "R\u00e9essayer",
    errorNoSubscription: "Aucun abonnement actif trouv\u00e9.",
    errorGeneric: "Une erreur est survenue. Veuillez r\u00e9essayer.",
  },
};

export default messages;
